<template>
    <div>
        <div v-for="(category) in categories">
            <div class="custom-categories-table-row custom-data-row modal-categories">
<!--                <div class="custom-categories-table-label">-->
<!--                    <span>{{category.id}}</span>-->
<!--                </div>-->
                <div class="custom-categories-table-label">{{category.name}}</div>
                <!--                <div class="custom-categories-table-label">-->
                <!--                    <img class="ap-table-img" :src="urlForStatic('/img/tmp/siding.svg')"/>-->
                <!--                </div>-->
                <div class="custom-categories-table-label">
                    <div v-if="Object.keys(category.subcategories).length === 0 || canChooseAny" class="buttons-group-collection field-edit" style="text-align: center">
                        <div class="table-svg-button" v-on:click="selectCategory(getHierarchy(category.id))">
                            <SVGPlus :width="20" :height="20"/>
                        </div>
                    </div>
                </div>
            </div>
            <ProductCategoriesRecursive style="margin-left: 15px; border-left: 2px solid #c5c5c5;" :canChooseAny="canChooseAny" :parents="getHierarchy(category.id)" :categories="category.subcategories"/>
        </div>
    </div>
</template>

<script>
import SVGPlus from "../../../SVG/SVGPlus";
import {bus} from "../../../../vue_bus";

export default {
    name: "ProductCategoriesRecursive",
    components: {
        SVGPlus
    },
    props: {
        'categories': {
            type: Object
        },
        'parents': {
            type: Array,
            default(){
                return [];
            }
        },
        'canChooseAny': {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    methods:{
        selectCategory(id){
            bus.$emit('productCategorySelected', id);
        },
        getHierarchy(id){
            return this.parents.concat([id]);
        }
    }
}
</script>

<style scoped>
    /*.modal-categories{*/
    /*    grid-template-columns: max-content auto 60px;*/
    /*}*/
</style>
